'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _utilsList = require('@bibliocommons/utils-list');

var _listJacketCover = require('../../list-jacket-cover');

var _listJacketCover2 = _interopRequireDefault(_listJacketCover);

var _anchorBibDescriptionInput = require('../../anchor-bib-description-input');

var _anchorBibDescriptionInput2 = _interopRequireDefault(_anchorBibDescriptionInput);

var _anchorBibSelector = require('../../anchor-bib-selector');

var _anchorBibSelector2 = _interopRequireDefault(_anchorBibSelector);

var _nameInput = require('../../name-input');

var _nameInput2 = _interopRequireDefault(_nameInput);

var _descriptionInput = require('../../description-input');

var _descriptionInput2 = _interopRequireDefault(_descriptionInput);

var _listOwner = require('../../list-owner');

var _listOwner2 = _interopRequireDefault(_listOwner);

var _listTypeDropdown = require('../../list-type-dropdown');

var _listTypeDropdown2 = _interopRequireDefault(_listTypeDropdown);

var _listType = require('../../list-type');

var _listType2 = _interopRequireDefault(_listType);

var _descriptionCharacterLimitExceededAlert = require('../../description-character-limit-exceeded-alert');

var _descriptionCharacterLimitExceededAlert2 = _interopRequireDefault(_descriptionCharacterLimitExceededAlert);

var _nameCharacterLimitExceededAlert = require('../../name-character-limit-exceeded-alert');

var _nameCharacterLimitExceededAlert2 = _interopRequireDefault(_nameCharacterLimitExceededAlert);

require('../styles/EditorHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditorHeader = exports.EditorHeader = function (_BcReactComponent) {
  _inherits(EditorHeader, _BcReactComponent);

  function EditorHeader(props) {
    _classCallCheck(this, EditorHeader);

    var _this = _possibleConstructorReturn(this, (EditorHeader.__proto__ || Object.getPrototypeOf(EditorHeader)).call(this, props));

    _this.bindAll('renderAnchorBib', 'renderReadalikeDescription', 'renderListJacketCover', 'renderListInfo', 'renderListTitle');
    return _this;
  }

  _createClass(EditorHeader, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.editingAnchorBib && this.props.editingAnchorBib) {
        this.focusOnAnchorBibSearch();
      } else if (prevProps.editingAnchorBib && !this.props.editingAnchorBib) {
        this.focusOnReadalikeDescription();
      }
    }
  }, {
    key: 'renderDescriptionMaxLengthExceededError',
    value: function renderDescriptionMaxLengthExceededError() {
      var _this2 = this;

      if ((0, _utilsList.listDescriptionIsTooLong)(this.props.list)) {
        return _react2.default.createElement(_descriptionCharacterLimitExceededAlert2.default, {
          ref: function ref(el) {
            return _this2._descriptionMaxLengthAlert = el;
          } });
      }

      return null;
    }
  }, {
    key: 'renderNameMaxLengthExceededError',
    value: function renderNameMaxLengthExceededError() {
      var _this3 = this;

      if ((0, _utilsList.listNameIsTooLong)(this.props.list)) {
        return _react2.default.createElement(_nameCharacterLimitExceededAlert2.default, {
          ref: function ref(el) {
            return _this3._nameMaxLengthAlert = el;
          } });
      }

      return null;
    }
  }, {
    key: 'focusOnError',
    value: function focusOnError() {
      if ((0, _utilsList.listNameIsTooLong)(this.props.list) && this._nameMaxLengthAlert) {
        this._nameMaxLengthAlert.focus();
      } else if ((0, _utilsList.listDescriptionIsTooLong)(this.props.list) && this._descriptionMaxLengthAlert) {
        this._descriptionMaxLengthAlert.focus();
      }
    }
  }, {
    key: 'focusOnAnchorBibSearch',
    value: function focusOnAnchorBibSearch() {
      if (this._anchorBibSelector) {
        this._anchorBibSelector.getWrappedInstance().getWrappedInstance().focusOnSearchInput();
      }
    }
  }, {
    key: 'focusOnReadalikeDescription',
    value: function focusOnReadalikeDescription() {
      if (this._readalikeListDescription) {
        this._readalikeListDescription.focus();
      }
    }
  }, {
    key: 'renderAnchorBib',
    value: function renderAnchorBib() {
      var _this4 = this;

      if (!this.props.list.get('anchorBib') || this.props.editingAnchorBib) {
        return _react2.default.createElement(_anchorBibSelector2.default, {
          ref: function ref(el) {
            return _this4._anchorBibSelector = el;
          },
          handleSearch: this.props.handleSearch,
          handleAnchorBibSelected: this.props.handleAnchorBibSelected,
          handleAddBib: this.props.handleAddBib,
          listItems: this.props.listItems,
          searchResults: this.props.searchResults,
          searchParams: this.props.searchParams,
          handleSearchParameterChange: this.props.handleSearchParameterChange,
          getNextPageSearchResults: this.props.getNextPageSearchResults,
          handleClearSearch: this.props.handleClearSearch });
      }

      return _react2.default.createElement(_anchorBibDescriptionInput2.default, {
        bib: this.props.list.get('anchorBib'),
        handleEditAnchorBib: this.props.handleEditAnchorBib,
        handleListPropertyChange: this.props.handleListPropertyChange });
    }
  }, {
    key: 'renderListType',
    value: function renderListType() {
      if ((0, _utilsList.isStaffOnlyList)(this.props.list)) {
        return _react2.default.createElement(_listType2.default, { type: this.props.list.get('listType') });
      }

      return _react2.default.createElement(_listTypeDropdown2.default, {
        handleListPropertyChange: this.props.handleListPropertyChange,
        listTypes: this.props.selectableListTypes,
        currentListType: this.props.list.get('listType') });
    }
  }, {
    key: 'renderListInfo',
    value: function renderListInfo() {
      if ((0, _utilsList.isReadalikeList)(this.props.list)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'hidden-xs' },
            _react2.default.createElement(_listOwner2.default, { owner: this.props.list.get('owner') })
          ),
          _react2.default.createElement(
            'h2',
            { className: 'list-heading if-you-liked' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_if_you_liked' })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'hidden-xs' },
          _react2.default.createElement(_listOwner2.default, { owner: this.props.list.get('owner') })
        ),
        this.renderListType()
      );
    }
  }, {
    key: 'renderYouWillLikeLabel',
    value: function renderYouWillLikeLabel() {
      var key = this.props.list.get('description') ? 'readalike_description_present_label' : 'readalike_description_empty_label';

      return _react2.default.createElement(
        'div',
        { className: 'you-will-like-these' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: key })
      );
    }
  }, {
    key: 'renderReadalikeDescription',
    value: function renderReadalikeDescription() {
      var _this5 = this;

      if (this.props.list.get('anchorBib')) {
        return _react2.default.createElement(
          'div',
          { tabIndex: '-1', ref: function ref(el) {
              return _this5._readalikeListDescription = el;
            } },
          this.renderYouWillLikeLabel(),
          _react2.default.createElement(_descriptionInput2.default, {
            value: this.props.list.get('description'),
            allowFreeText: this.props.allowFreeText,
            prompt: this.props.intl.formatMessage({ id: 'user_list_readalike_because' }),
            handleListPropertyChange: this.props.handleListPropertyChange })
        );
      }
      return false;
    }
  }, {
    key: 'renderListTitle',
    value: function renderListTitle() {
      if ((0, _utilsList.isReadalikeList)(this.props.list)) {
        return (
          // A non-empty form action is required for having a search button appear on iOS 8+
          // See http://stackoverflow.com/questions/4864167/show-search-button-in-iphone-ipad-safari-keyboard
          _react2.default.createElement(
            'form',
            { action: '.' },
            this.renderAnchorBib(),
            this.renderReadalikeDescription(),
            this.renderDescriptionMaxLengthExceededError()
          )
        );
      }

      return _react2.default.createElement(
        'form',
        { action: '' },
        _react2.default.createElement(_nameInput2.default, {
          value: this.props.list.get('name'),
          listNameExamples: this.props.listNameExamples,
          allowFreeText: this.props.allowFreeText,
          handleListPropertyChange: this.props.handleListPropertyChange }),
        this.renderNameMaxLengthExceededError(),
        _react2.default.createElement(_descriptionInput2.default, {
          value: this.props.list.get('description'),
          allowFreeText: this.props.allowFreeText,
          handleListPropertyChange: this.props.handleListPropertyChange }),
        this.renderDescriptionMaxLengthExceededError()
      );
    }
  }, {
    key: 'renderListJacketCover',
    value: function renderListJacketCover() {
      var anchorBibJacketCover = (0, _utilsList.isReadalikeList)(this.props.list) ? this.props.list.getIn(['anchorBib', 'jacketCover']) : null;

      return _react2.default.createElement(_listJacketCover2.default, {
        isDraft: this.props.list.get('isDraft'),
        listType: this.props.list.get('listType'),
        anchorBibJacketCover: anchorBibJacketCover,
        src: this.props.jacketCoverImgSrc.get('localUrl') });
    }
  }, {
    key: 'render',
    value: function render() {
      var selectAnchorClass = !(0, _utilsList.isReadalikeList)(this.props.list) || this.props.list.get('anchorBib') ? '' : 'select-anchor';
      var classes = 'cp-editor-header row banner-row ' + selectAnchorClass;
      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: 'hidden-xs col-sm-3 col-md-4 col-lg-3 anchor-bib' },
          this.renderListJacketCover()
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-9 col-md-8 col-lg-9 col-md-offset-4 col-lg-offset-3 header-block' },
          this.renderListInfo(),
          this.renderListTitle()
        )
      );
    }
  }], [{
    key: 'formatJacketCoverSrc',
    value: function formatJacketCoverSrc(jacket) {
      return _immutable2.default.Map({
        small: jacket.get('smallCover'),
        medium: jacket.get('mediumCover'),
        large: jacket.get('largeCover'),
        local_url: jacket.get('localUrl'),
        type: jacket.get('type')
      });
    }
  }]);

  return EditorHeader;
}(_baseBcReactComponent2.default);

EditorHeader.propTypes = {
  list: _bcPropTypes.listShape,
  handleSearch: _react.PropTypes.func.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map,
  jacketCoverImgSrc: _react.PropTypes.shape({
    localUrl: _react.PropTypes.string,
    largeCover: _react.PropTypes.string,
    mediumCover: _react.PropTypes.string,
    smallCover: _react.PropTypes.string,
    type: _react.PropTypes.string
  }),
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  allowFreeText: _react.PropTypes.bool.isRequired,
  listNameExamples: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  selectableListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),

  handleEditAnchorBib: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,

  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(EditorHeader, { withRef: true });


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-header/components/EditorHeader.component.js
// module id = 1292
// module chunks = 0